export function scrollToElement(selector: string) {
  document.querySelector(selector)?.scrollIntoView({ behavior: 'smooth' });
}
